import { BASE_URL } from './const'
import flat from './flat'
/**
 * 获取铜板商城list
 * @returns
 */
export const getProductList = () => {
  //api/mall/proxy/creditmall/get_credit_goods
  return flat(`${BASE_URL}/api/mall/proxy/creditmall/get_goods?type=0`)
}

export const getCreditRecords = () => {
  return flat(`${BASE_URL}/api/mall/proxy/creditmall/get_credit_records`)
}

export const checkReplaceToDuiba = () => {
  return flat(`${BASE_URL}/api/study/credit/duiba/enable_duiba`)
}

export const checkDui8Accessible = () =>
  new Promise(res => {
    const request = new XMLHttpRequest()
    request.open('HEAD', 'https://yun.duiba.com.cn/images/201701/56qn50o6hy.jpg')
    request.onload = function () {
      if (request.status != 200) {
        res(false)
      } else {
        res(true)
      }
    }
    request.send()
    setTimeout(() => res(false), 2000)
  })

/**
 * 获取授权过后的对吧链接
 * @param {string} url
 * @returns
 */
export function getLoginUrl(url) {
  return flat(`${BASE_URL}/api/study/credit/duiba/loginUrl?url=${url}`)
}
